import React from "react";
import { createPortal } from "react-dom";
import styled, { keyframes } from "styled-components";
import { TestTarget } from "../../types/TestTarget";
import TestTargetDetailView from "../TestTargetDetailView";

// アニメーション
const fadeIn = keyframes`
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

// ウィンドウコンテナ（カスケード表示対応）
const WindowContainer = styled.div<{ position: { x: number; y: number } }>`
  position: fixed;
  top: ${(props) => props.position.y}px;
  left: ${(props) => props.position.x}px;
  z-index: 3100;
  animation: ${fadeIn} 0.2s ease-out;
  pointer-events: auto;

  /* 編集ボタンを非表示にする */
  button[title="編集"] {
    display: none !important;
  }
`;

interface TargetDetailWindowProps {
  open: boolean;
  onClose: () => void;
  testTarget: TestTarget;
  testTargets: TestTarget[];
  position: { x: number; y: number };
  testcaseMappings?: import("../../services/api").TestcaseMappings | null;
}

export const TargetDetailWindow: React.FC<TargetDetailWindowProps> = ({
  open,
  onClose,
  testTarget,
  testTargets,
  position,
  testcaseMappings,
}) => {
  // TestTargetDetailViewは編集ボタンを表示するが、onSaveを空関数にして編集を無効化
  const handleSave = async () => {
    // 参照専用なので保存処理は行わない
  };

  if (!open) return null;

  return createPortal(
    <WindowContainer position={position}>
      <TestTargetDetailView
        open={open}
        onClose={onClose}
        onSave={handleSave}
        testTarget={testTarget}
        testTargets={testTargets}
        initialMode="view"
        initialTab="basic"
        testcaseMappings={testcaseMappings}
        zIndex={3100}
        hideEditButton={true}
      />
    </WindowContainer>,
    document.body
  );
};

